'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = DottedStat;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _style = require('../style');

var _browserVendorPrefix = require('browser-vendor-prefix');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function DottedStat(props) {
  var wrapperStyle = _extends({}, style.wrapper, props.style);

  var dots = [];
  for (var i = 0; i < props.number; i++) {
    dots.push(_react2['default'].createElement('span', { style: style.dot, key: i }));
  }

  var text = undefined;
  switch (props.number) {
    case 0:
    case 1:
      text = props.text[props.number];
      break;
    default:
      text = props.number + ' ' + props.text.many;
      break;
  }

  return _react2['default'].createElement(
    'div',
    { style: wrapperStyle },
    _react2['default'].createElement(
      'span',
      { style: style.text },
      text
    ),
    props.number > 0 && _react2['default'].createElement(
      'div',
      { style: style.dots },
      dots
    )
  );
}

;

var style = {
  dot: {
    backgroundColor: _style.BLUE,
    borderRadius: 10,
    marginRight: 2,
    marginTop: 2,
    height: 10,
    width: 10
  },
  dots: _extends({}, _browserVendorPrefix.flexDirectionRow, _browserVendorPrefix.flexWrapWrap, {
    width: '95%'
  }),
  dotsWrapper: _browserVendorPrefix.flexDirectionRow,
  wrapper: {
    marginTop: 10
  }
};
module.exports = exports['default'];